<template>
  <div class="details-tab p-4">
    <div v-if="!!course.is_online" class="text-center">
      <a
        v-if="
          !hideEnrollButtons &&
          !course.hide_from_catalog &&
          !this.course.in_queue &&
          !!this.course.can_enroll
        "
        class="btn btn-primary mr-2 mb-2"
        href="#"
        @click.prevent="enrollMyself(course)"
        >Register Myself</a
      >
      <a
        v-if="
          !hideEnrollButtons && !course.hide_from_catalog && !$root.isLoggedIn
        "
        class="btn btn-primary mr-2 mb-2"
        :href="route('login')"
        >Register</a
      >
      <a
        v-if="
          !hideEnrollButtons &&
          !course.hide_from_catalog &&
          !!this.course.can_enroll_others
        "
        class="btn btn-primary mr-2 mb-2"
        href="#"
        @click.prevent="enrollOthers(course)"
        >Register Others</a
      >
      <a
        v-if="!hideLaunchButton && !!course.can_launch && !!course.launch_url"
        class="btn btn-primary mr-2 mb-2"
        :href="course.launch_url"
        target="_blank"
        >Launch Course</a
      >
      <a
        v-else-if="!hideLaunchButton && !!course.show_prereq_notice"
        class="btn btn-primary mr-2 mb-2"
        href="#"
        @click.prevent="showPrerequisiteNotice()"
        >Launch Course</a
      >
    </div>

    <CourseOverview
      :course="course"
      :enrollment="enrollment"
      class="details-pane-table mt-4"
    />

    <div v-if="!!course.video_url" class="course-video-wrap text-center">
      <hr />
      <video
        class="course-video"
        :src="course.video_url"
        :poster="course.image_url"
        controls
        controlslist="nodownload"
        oncontextmenu="return false;"
      />
    </div>

    <template v-if="!hideDescription">
      <div v-if="!!course.excerpt" class="course-description">
        <hr />
        <h4 class="mb-3">Course Description</h4>
        <p v-html="course.excerpt"></p>
      </div>
      <div v-if="!!detailsUrl && !course.hide_from_catalog" class="text-center">
        <a :href="detailsUrl" class="btn btn-primary mt-3">View Full Details</a>
      </div>
    </template>
  </div>
</template>

<script>
import CourseOverview from "../CourseOverview";
import EnrollmentMixin from "mixins/Courses/HandlesCourseEnrollment";
import PrerequisiteNotice from "components/pages/registration/partials/PrerequisiteNotice";

export default {
  mixins: [EnrollmentMixin],
  components: { CourseOverview, PrerequisiteNotice },
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object },
    detailsUrl: { type: String },
    hideDescription: { type: Boolean, default: false },
    hideEnrollButtons: { type: Boolean, default: false },
    hideLaunchButton: { type: Boolean, default: false },
  },
  computed: {
    routeParam() {
      return { course: this.course.id };
    },
  },
  methods: {
    showPrerequisiteNotice() {
      this.$modal(PrerequisiteNotice)
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.course-video {
  width: 100%;
  max-width: 23.363vw;
  height: 13.142vw;
}
</style>